var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            lg12: "",
            "ml-3": "",
            "pt-2": "",
            "mb-2": "",
          },
        },
        [
          _c(
            "v-icon",
            {
              staticStyle: { "font-size": "20px" },
              on: {
                click: function ($event) {
                  return _vm.routeTo(0)
                },
              },
            },
            [_vm._v("home")]
          ),
          _vm._v(" "),
          _vm._l(_vm.breadcrumbList, function (breadcrumb, idx) {
            return _c(
              "span",
              {
                key: idx,
                on: {
                  click: function ($event) {
                    return _vm.routeTo(idx)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "grey--text text--darken-1",
                    staticStyle: { "font-size": "16", "font-weight": "bold" },
                  },
                  [
                    _c("v-icon", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("chevron_right"),
                    ]),
                    _vm._v(" "),
                    breadcrumb.link != null
                      ? [_c("a", [_vm._v(" " + _vm._s(breadcrumb.name) + " ")])]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "ml-3 mt-2" }, [
            _vm._v(" " + _vm._s(_vm.pageTitle) + " "),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.currentPage
        ? _c(
            _vm.currentPage.component,
            _vm._b(
              {
                tag: "component",
                on: {
                  navigate: _vm.onNavigate,
                  setPageTitle: _vm.setPageTitle,
                },
              },
              "component",
              _vm.currentPageAttributes,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }